import React from 'react';
import { Link } from 'react-router-dom';
import { PhoneIcon, MailIcon, MapPinIcon, ClockIcon } from 'lucide-react';
const Footer = () => {
  return <footer className="bg-[#0a3d62] text-white pt-12 pb-6" data-id="element-66">
      <div className="container mx-auto px-4" data-id="element-67">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8" data-id="element-68">
          {/* Company Info */}
          <div data-id="element-69">
            <h3 className="text-xl font-semibold mb-4" data-id="element-70">PinnacleHub</h3>
            <p className="text-gray-300 mb-4" data-id="element-71">
              Your trusted partner for fast, reliable appliance repairs across
              the UK. We provide professional service with fixed-price plans and
              UK-based support.
            </p>
            <div className="flex items-center space-x-2 text-gray-300 mb-2" data-id="element-72">
              <MapPinIcon size={18} data-id="element-73" />
              <span data-id="element-74">56 Main St, Glasgow G71 7LS</span>
            </div>
            <div className="flex items-center space-x-2 text-gray-300 mb-2" data-id="element-75">
              <PhoneIcon size={18} data-id="element-76" />
              <span data-id="element-77">0800 055 4969</span>
            </div>
            <div className="flex items-center space-x-2 text-gray-300" data-id="element-78">
              <MailIcon size={18} data-id="element-79" />
              <span data-id="element-80">Bikashbuddha2004@gmail.com</span>
            </div>
          </div>
          {/* Quick Links */}
          <div data-id="element-81">
            <h3 className="text-xl font-semibold mb-4" data-id="element-82">Quick Links</h3>
            <ul className="space-y-2" data-id="element-83">
              <li data-id="element-84">
                <Link to="/" className="text-gray-300 hover:text-[#3fc1c9] transition-colors" data-id="element-85">
                  Home
                </Link>
              </li>
              <li data-id="element-86">
                <Link to="/service-coverage" className="text-gray-300 hover:text-[#3fc1c9] transition-colors" data-id="element-87">
                  Service Coverage
                </Link>
              </li>
              <li data-id="element-88">
                <Link to="/about" className="text-gray-300 hover:text-[#3fc1c9] transition-colors" data-id="element-89">
                  About Us
                </Link>
              </li>
              <li data-id="element-90">
                <Link to="/contact" className="text-gray-300 hover:text-[#3fc1c9] transition-colors" data-id="element-91">
                  Contact Us
                </Link>
              </li>
              <li data-id="element-92">
                <Link to="/faq" className="text-gray-300 hover:text-[#3fc1c9] transition-colors" data-id="element-93">
                  FAQs
                </Link>
              </li>
            </ul>
          </div>
          {/* Opening Hours */}
          <div data-id="element-94">
            <h3 className="text-xl font-semibold mb-4" data-id="element-95">Opening Hours</h3>
            <div className="space-y-2 text-gray-300" data-id="element-96">
              <div className="flex items-center space-x-2" data-id="element-97">
                <ClockIcon size={18} data-id="element-98" />
                <span className="font-medium" data-id="element-99">Customer Service</span>
              </div>
              <div className="flex justify-between" data-id="element-100">
                <span data-id="element-101">Monday - Friday:</span>
                <span data-id="element-102">9:00am - 5:00pm</span>
              </div>
              <div className="flex justify-between" data-id="element-103">
                <span data-id="element-104">Saturday:</span>
                <span data-id="element-105">Closed</span>
              </div>
              <div className="flex justify-between" data-id="element-106">
                <span data-id="element-107">Sunday:</span>
                <span data-id="element-108">Closed</span>
              </div>
            </div>
            {/* Payment Methods */}
            <div className="mt-6" data-id="element-109">
              <h4 className="text-sm font-semibold mb-2" data-id="element-110">Payment Methods</h4>
              <div className="flex space-x-3" data-id="element-111">
                <span className="bg-white text-[#0a3d62] px-2 py-1 rounded text-xs font-medium" data-id="element-112">
                  Visa
                </span>
                <span className="bg-white text-[#0a3d62] px-2 py-1 rounded text-xs font-medium" data-id="element-113">
                  Mastercard
                </span>
                <span className="bg-white text-[#0a3d62] px-2 py-1 rounded text-xs font-medium" data-id="element-114">
                  PayPal
                </span>
              </div>
            </div>
          </div>
          {/* Family Image */}
          <div className="md:col-span-2 lg:col-span-1" data-id="element-115">
            <h3 className="text-xl font-semibold mb-4" data-id="element-116">Happy Customers</h3>
            <div className="rounded-lg overflow-hidden" data-id="element-117">
              <img src="https://images.unsplash.com/photo-1600880292203-757bb62b4baf?ixlib=rb-1.2.1&auto=format&fit=crop&w=500&q=80" alt="Happy family in kitchen" className="w-full h-48 object-cover" data-id="element-118" />
            </div>
          </div>
        </div>
        {/* Policies */}
        <div className="mt-8 pt-6 border-t border-[#1e5f82]" data-id="element-119">
          <div className="flex flex-wrap gap-4 justify-center text-sm text-gray-300 mb-6" data-id="element-120">
            <Link to="/cancellation-policy" className="hover:text-[#3fc1c9] transition-colors" data-id="element-121">
              Cancellation Policy
            </Link>
            <Link to="/refund-policy" className="hover:text-[#3fc1c9] transition-colors" data-id="element-122">
              Refund Policy
            </Link>
            <Link to="/privacy-policy" className="hover:text-[#3fc1c9] transition-colors" data-id="element-123">
              Privacy & Cookie Policy
            </Link>
            <Link to="/terms-conditions" className="hover:text-[#3fc1c9] transition-colors" data-id="element-124">
              Terms & Conditions
            </Link>
          </div>
          <p className="text-center text-sm text-gray-400" data-id="element-125">
            © {new Date().getFullYear()} PinnacleHub. All rights reserved.
          </p>
        </div>
      </div>
    </footer>;
};
export default Footer;